import { API_URL } from 'constants/env'

export const SOCKET_URL = API_URL
